import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import API from "../../actions/api-helper.js";
import UI from "../../actions/ui-helper.js";

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      senha: ""
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleSubmit(event) {
    var data = this.state;

    API.post("/acesso/login", data)
      .then((json) => {
        if (json.success) {
          localStorage.setItem("accessToken", json.data.accessToken);
          if (json.data.usuario.senhaProvisoria) {
            UI.toggleModal("#alterar-senha-modal");
          } else {
            //this.props.history.push("/inicio");
            window.location.href = "/inicio";
          }
        } else {
          UI.alert(false, json.message);
        }
      })
      .catch((json) => {
        UI.alert(false, json.message);
      });

    event.preventDefault();
  }

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({ [name]: name === "email" ? value.toUpperCase() : value });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} autoComplete="off" spellCheck="false">
        <div className="form-group">
          <label className="label">E-mail</label>
          <div className="input-group">
            <input
              name="email"
              type="text"
              className="form-control"
              placeholder=""
              onChange={this.handleChange}
              autoFocus
              value={this.state.email}
            />
            <div className="input-group-append">
              <span className="input-group-text">
                <i className="icon-check" />
              </span>
            </div>
          </div>
        </div>
        <div className="form-group">
          <label className="label">Senha</label>
          <div className="input-group">
            <input
              name="senha"
              type="password"
              className="form-control"
              placeholder="********"
              onChange={this.handleChange}
            />
            <div className="input-group-append">
              <span className="input-group-text">
                <i className="icon-check" />
              </span>
            </div>
          </div>
        </div>
        <div className="form-group">
          <button className="btn btn-primary submit-btn btn-block">
            Entrar
          </button>
        </div>
      </form>
    );
  }
}

export default withRouter(LoginForm);
